const imageHost   = 'https://cdn.133.cn';
const imagePath   = '/gtgj/web/virusTrip/';
const imagePrefix = imageHost + imagePath;

const imageMap = {
  trainIcon      : imagePrefix + 'train-icon.png',
  flightIcon     : imagePrefix + 'flight-icon.png',
  hotelIcon      : imagePrefix + 'hotel-icon.png',
  logo           : imagePrefix + 'logo.png',
  flight         : imagePrefix + 'flight.png',
  train          : imagePrefix + 'train.png',
  subway         : imagePrefix + 'subway.png',
  coach          : imagePrefix + 'coach.png',
  bus            : imagePrefix + 'bus.png',
  taxi           : imagePrefix + 'taxi.png',
  ship           : imagePrefix + 'ship.png',
  other          : imagePrefix + 'other.png',
  empty          : imagePrefix + 'empty.png',
  arrow          : imagePrefix + 'arrow.png',
  spinner        : imagePrefix + 'spinner.png',
  share20200130  : imagePrefix + 'share-20200130.png',
  shareArrow     : imagePrefix + 'share-arrow.png',
  banner         : imagePrefix + 'banner-20200203.png',
  backButton     : imagePrefix + 'back-button.png',
  logo20200205   : imagePrefix + 'logo-20200205.png',
  logo20200206   : imagePrefix + 'logo-20200206.png',
  banner20200218 : imagePrefix + 'banner-20200218.png',
  banner20200217 : imagePrefix + 'banner-20200217.png'
};

export default imageMap;



// WEBPACK FOOTER //
// ./src/projects/virusTrip/image-map.js